import React, { Component, createRef } from 'react';
import { Col, Row, Label, FormGroup, Form, Container, Alert, Table } from 'reactstrap';

export default class Board extends Component {
    constructor(props) {
        super(props);

        this.state = {    
            board: {},
            boardMembers: []
        };                  
    }

    iCompass = createRef();

    componentDidMount() {
        const { id } = this.props.match.params;
        //return board information
        fetch('/api/boards/' + id, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ board: data });

                if (data.icompassBoardId && data.icompassMeetingTypeId) {                    
                    //load iCompass meeting list script     
                    let script = document.createElement("script");
                    script.type = "text/javascript";
                    script.id = "iCompassScript";
                    script.src = "https://stlouisco.civicweb.net/js/plugins/meetinglist?t=" + data.icompassBoardId
                    script.async = true;
                    script.setAttribute("data-type", "civicweb-meeting-list");
                    script.setAttribute("data-meeting-count", "10");
                    script.setAttribute("data-id", data.icompassMeetingTypeId);
                    script.onload = function () {
                        window.CivicWeb.Plugins.MeetingList.runOnce = false;
                    }                      
                    this.iCompass.current.appendChild(script);
                }
            })

        //return members
        fetch('/api/boardmembers/GetBoardMembersByBoardId/' + id, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ boardMembers: data });
            })
    }

    render() {   
        const { board, boardMembers } = this.state;
        let vacancies = [];
        
        for(let i = 0; i < board.totalSeats - boardMembers.length; i++){
            vacancies.push(
                <tr key={i}>
                    <td colSpan='4'>Vacant Seat</td>
                </tr>
            )
        }

        return (            
            <Form id="board">
                <FormGroup>
                    <Container className="form-border">
                        <hr />
                        <h5>
                            <div className="row justify-content-between" style={{ padding: "0px 20px" }}>
                                <div className="float-left">
                                    Board Information
                                </div>
                            </div>
                        </h5>
                        <hr />
                        <Row>                            
                            <Col className="col-12">
                                <FormGroup>
                                    <Label>Board Name</Label>
                                    <Alert color="secondary">{this.state.board.name}</Alert>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="col-12">
                                <FormGroup>
                                    <Label>Description</Label>
                                    <Alert color="secondary">
                                        {this.state.board.description && this.state.board.description.split("\n").map((desc, i) => {
                                            return <div key={i}>{desc}<br /></div>
                                        })}
                                    </Alert>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">
                        <hr />
                        <h5>Board Members</h5>
                        <hr />
                        <Row>
                            <Col className="col-12">
                                <Table className="mobile-table" bordered responsive striped>
                                    <thead>
                                        <tr>
                                            <th>Member Name</th>
                                            <th>Title</th>
                                            <th>Position</th>
                                            <th>Expiration Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.boardMembers.length === 0 &&
                                            <tr><td colSpan='4'>There are no members on this board.</td></tr>
                                        }
                                        {this.state.boardMembers && this.state.boardMembers.length > 0 && this.state.boardMembers.map((m) => {
                                            return (      
                                                <tr key={m.id}>
                                                    <td data-title="Member Name">
                                                        {(m.firstName ? m.firstName + " " : "") + (m.middleName ? m.middleName + " " : "") + (m.lastName ? m.lastName : "")}
                                                    </td>
                                                    <td data-title="Title">{m.title}</td>
                                                    <td data-title="Position">{m.position}</td>
                                                    <td data-title="Expiration Date">{m.expirationDate ? new Date(m.expirationDate).toLocaleDateString("en-US") : ""}</td>
                                                </tr>
                                            )
                                        })}
                                        {vacancies}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </FormGroup>
                <FormGroup>
                    <Container className="form-border">      
                        <hr />
                        <h5>Meetings</h5>
                        <hr />
                        {(!this.state.board.icompassBoardId || !this.state.board.icompassMeetingTypeId) &&
                            <div className="p-2" style={{backgroundColor: "#f2f2f2", border: "1px solid #dee2e6"}}>There are no meetings available for this board.</div>
                        }                        
                        <div ref={this.iCompass} />                            
                    </Container>
                </FormGroup>                
            </Form>
        )
    }
}